'use client';
import React, { useEffect, useState, type ComponentType } from 'react';
import Icon from '@/components/ui/AppIcon';


interface ClientIconProps {
  icon: ComponentType<{ size?: number; className?: string }>;
  size?: number;
  className?: string;
}

export default function ClientIcon({ icon: Icon, size, className }: ClientIconProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Render a placeholder with the same dimensions to avoid layout shift
    return (
      <svg
        width={size ?? 16}
        height={size ?? 16}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      />
    );
  }

  return <Icon size={size} className={className} />;
}
